var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errors)?_c('div',{staticClass:"validation-summary text-danger"},[_vm._v(" "+_vm._s(_vm.errors.single_err_msg)+" "),(!_vm.errors.is_single_error)?_c('ul',_vm._l(([]),function(error){return _c('li',[_vm._v(" "+_vm._s(error)+" ")])}),0):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }